import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Rx';
import {WebcamImage} from 'ngx-webcam';

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: []
})
export class CameraComponent implements OnInit, OnDestroy {

  @Output() imageCapture: EventEmitter<WebcamImage> = new EventEmitter<WebcamImage>();
  @Output() cameraInit: EventEmitter<void> = new EventEmitter<void>();

  private trigger: Subject<void> = new Subject<void>();
  private readonly VIDEO_ELEMENT_SELECTOR = '.camera video';

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  constructor() { }

  ngOnInit() {
    this.handleVideoLoadedDataEvent = this.handleVideoLoadedDataEvent.bind(this);
    this.handleCameraInit();
  }

  ngOnDestroy(): void {
    if (document.querySelector(this.VIDEO_ELEMENT_SELECTOR)) {
      document.querySelector(this.VIDEO_ELEMENT_SELECTOR).removeEventListener('loadeddata', this.handleVideoLoadedDataEvent);
    }
  }

  capture(): void {
    this.trigger.next();
  }

  handleCameraInit(): void {
    if (document.querySelector(this.VIDEO_ELEMENT_SELECTOR)) {
      document.querySelector(this.VIDEO_ELEMENT_SELECTOR).addEventListener('loadeddata', this.handleVideoLoadedDataEvent);
    }
  }

  private handleVideoLoadedDataEvent(): void {
    this.cameraInit.emit();
  }

}
